import { DateTime } from "luxon";
import { BigNumber } from "bignumber.js";
import React from "react";
let currencySymbol = "$";

const { REACT_APP_TIMEZONE = "UTC+8" } = process.env;

const Utils = {
  setCurrencySymbol(s: string) {
    currencySymbol = s;
  },
  changeFraction(v: number | BigNumber, maxFraction: number = 4): string {
    if (typeof v === "number") {
      v = BigNumber(v);
    }
    const result = v.toString().match(`(-?[0-9]*).?([0-9]{0,${maxFraction}})`);
    if (!result) return "";

    if ((result.at(2)?.length ?? 0) > 0) {
      // floating number
      return `${result.at(1)}.${result.at(2)?.padEnd(2, "0")}`;
    }

    return (+(result.at(1) ?? 0)).toLocaleString("en") ?? "0";
  },
  asCurrency(v: number | BigNumber, maxFraction: number = 4): string {
    if (typeof v === "number") {
      v = BigNumber(v);
    }
    let n = this.changeFraction(v, maxFraction);
    let negetiveSign = "";
    if (v.lt(0)) {
      n = n.slice(1);
      negetiveSign = "-";
    }
    return `${negetiveSign}${currencySymbol}${n}`;
  },
  randomId(): string {
    return Math.random().toString(16).substring(3, 14);
  },
  changeTimezoneAndFormat(v: string): string {
    const datetime = DateTime.fromISO(v);
    return `${datetime.setZone(REACT_APP_TIMEZONE).toFormat("dd/MM/yyyy TT", {
      locale: "en",
    })} (${REACT_APP_TIMEZONE})`;
  },
  drawLine(maxY: number, matchPosition: number[]): React.ReactNode {
    return (
      <div className="d-flex justify-content-center">
        <div className="d-flex border border-secondary border-2 rounded">
          {matchPosition.map((s, x) => (
            <div key={x} className="d-flex flex-column">
              {Array.from({ length: maxY }, (_, i) => (
                <div
                  key={i}
                  className={
                    "border border-dark border-1 rounded-1" +
                    (s === i ? " bg-warning " : "")
                  }
                  style={{ width: "1rem", height: "1rem", margin: "0.1rem" }}
                ></div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  },
} as const;

export default Utils;
